export default "varying vec2 v_uv;\n\nvoid main() {\n  v_uv = uv;\n  gl_Position = projectionMatrix * modelViewMatrix * vec4(position, 1.0);\n}"